import StatementExchangeBets from "app/screens/ReportsScreen/components/DesktopReportsScreen/components/StatementScreen/components/StatementExchange/StatementExchangeBets/StatementExchangeBets";
import StatementExchangeMarket from "app/screens/ReportsScreen/components/DesktopReportsScreen/components/StatementScreen/components/StatementExchange/StatementExchangeMarket/StatementExchangeMarket";
import {
  AsianReportViewTypes as ViewTypes,
  AsianStatementTabTypes as TabTypes,
} from "app/utils/const";
import React, { lazy, Suspense, useEffect } from "react";
const AsianStatementSummary: React.LazyExoticComponent<any> = lazy(
  () => import("../AsianStatementSummary/AsianStatementSummary")
);
const AsianStatementNormal: React.LazyExoticComponent<any> = lazy(
  () => import("../AsianStatementNormal/AsianStatementNormal")
);
const AsianStatementLeague: React.LazyExoticComponent<any> = lazy(
  () => import("../AsianStatementLeague/AsianStatementLeague")
);
const AsianStatementMatch: React.LazyExoticComponent<any> = lazy(
  () => import("../AsianStatementMatch/AsianStatementMatch")
);
const AsianStatementFunding: React.LazyExoticComponent<any> = lazy(
  () => import("../AsianStatementFunding/AsianStatementFunding")
);
type Props = {
  resetFilter: (...args: Array<any>) => any;
  query: string;
  currentView: string;
  onClickSummaryDate: (...args: Array<any>) => any;
  showBalanceHeaders: boolean;
  tab: string;
  previousView: string;
  isFundingType: any;
  fetchNormalListByType: (...args: Array<any>) => any;
};

const AsianStatementScreenCurrentView: React.FC<Props> = props => {
  const {
    resetFilter,
    query,
    currentView,
    onClickSummaryDate,
    showBalanceHeaders,
    tab,
    previousView,
    isFundingType,
    fetchNormalListByType,
  } = props;
  let view: HTMLElement | any = null;

  useEffect(() => {
    // Add any side effects or lifecycle methods here
  }, []);

  switch (currentView) {
    case ViewTypes.SUMMARY:
      view = (
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <AsianStatementSummary
            resetFilter={resetFilter}
            query={query}
            onClickSummaryDate={onClickSummaryDate}
            showBalanceHeaders={showBalanceHeaders}
          />
        </Suspense>
      );
      break;

    case ViewTypes.NORMAL:
      if (
        (tab === TabTypes.FUNDING && previousView === ViewTypes.SUMMARY) ||
        (tab === TabTypes.ALL &&
          previousView === ViewTypes.SUMMARY &&
          isFundingType)
      ) {
        view = (
          <Suspense fallback={<div className="fallback">loading...</div>}>
            <AsianStatementSummary
              resetFilter={resetFilter}
              query={query}
              onClickSummaryDate={onClickSummaryDate}
              showBalanceHeaders={
                tab === TabTypes.ALL && currentView === ViewTypes.SUMMARY
              }
            />
          </Suspense>
        );
      } else {
        view = (
          <Suspense fallback={<div className="fallback">loading...</div>}>
            <AsianStatementNormal
              resetFilter={resetFilter}
              query={query}
              tab={tab}
            />
          </Suspense>
        );
      }

      break;

    case ViewTypes.LEAGUE:
      view = (
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <AsianStatementLeague
            resetFilter={resetFilter}
            query={query}
            loadLeagueNormalList={fetchNormalListByType}
          />
        </Suspense>
      );
      break;

    case ViewTypes.MATCH:
      view = (
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <AsianStatementMatch
            resetFilter={resetFilter}
            query={query}
            loadMatchNormalList={fetchNormalListByType}
          />
        </Suspense>
      );
      break;

    case TabTypes.FUNDING:
      view = (
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <AsianStatementFunding
            resetFilter={resetFilter}
            query={query}
            tab={tab}
          />
        </Suspense>
      );
      break;
    case ViewTypes.EXCHANGE_BETTING:
      view = (
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <StatementExchangeMarket />
        </Suspense>
      );
      break;
    case ViewTypes.EXCHANGE_BETTING_BET:
      view = (
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <StatementExchangeBets />
        </Suspense>
      );
      break;

    default:
      break;
  }

  return (
    <>
      <Suspense fallback={<div className="fallback">loading...</div>}>
        {view}
      </Suspense>
    </>
  );
};

export default AsianStatementScreenCurrentView;
